import "./SiteConfigurationGroupAdd.html";

import type { IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import SiteConfigurationGroupAddComponentController from "./SiteConfigurationGroupAddComponentController";

export class SiteConfigurationGroupAddComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = SiteConfigurationGroupAddComponentController;
        this.templateUrl = "/App/Components/Site/ConfigurationGroups/Add/SiteConfigurationGroupAdd.html";
    }
}

module("mmManagePortal").component("mmSiteConfigurationGroupAdd", new SiteConfigurationGroupAddComponent());
